import React, { Ref } from "react";
import classNames from "classnames";
import { forwardRef, useImperativeHandle } from "react";
import useCountdown from "~src/hooks/useCountdown";
import styles from "./index.module.less";
import { QuestionCircleRef } from "~src/service/answer/answer";

interface QuestionCircleProps {
  onClickHalbzeit?:() => void
  onClickCountdown?:() => void
}
const Circle = (props:QuestionCircleProps, ref:Ref<QuestionCircleRef>) => {
  const {onClickHalbzeit,onClickCountdown} = props
  const onHalbzeit = () => {
    onClickHalbzeit&&onClickHalbzeit()
  };
  const onCountdown = () => {
    onClickCountdown&&onClickCountdown()
  };
  const { count,restartCountdown,stopCountdown,setCountText } = useCountdown(15000, onHalbzeit, onCountdown);
  useImperativeHandle(ref, () => ({
    restartCountdown,
    setCountText,
    "stopCountdown": () => {
      localStorage.setItem("lv_count_down", String(count))
      stopCountdown()
    }
  }), [count, restartCountdown, setCountText, stopCountdown])
  return <div className={classNames(styles["question-circle"], count< 15000/2 ? styles["question-circle-dearth"]: styles["question-circle-adequate"])}>
    <div className={styles["question-circle-title"]}>剩余时间</div>
    <div className={classNames(styles["question-circle-num"], styles["question-circle-success"])}>{Math.ceil(count/1000)}</div>
  </div>
}

export default forwardRef<QuestionCircleRef, QuestionCircleProps>(Circle);